import React from 'react'
import {   Field} from 'redux-form'

import DateTimePicker from 'react-widgets/lib/DateTimePicker'

import 'react-widgets/dist/css/react-widgets.css'


const svpicker = ({input:{ onChange, value}, showTime})=>{
    console.log('sv datetime picker')
        console.log(value)
       let dt = null
        if(typeof(value) =='string'){
            dt = new Date()
        }else if(  (typeof(value) =='object')  ){
        
            console.log('sv date instance')
            console.log(value)
            
            dt = new Date(value)
        }else{
            dt = new Date()
        }
        dt = new Date()
        console.log('date is dt:', dt)
    return(
    <DateTimePicker  onChange={onChange} format="DD MMM YYYY"  time={showTime}  value={dt} />
)}



export class SVDate extends React.Component{
    

    constructor(props){
        super(props)
        this.svchange   = this.svchange.bind(this)


    }
    componentWillReceiveProps(next){
        console.log('sv number')
        console.log(next)

    }

    svchange(input){
        console.log('svchange')
        input.onBlur()
    }

    render(){
        console.log('render svdate')
        console.log(this.props)

        let me = this

        const  { portId, children} = this.props
        const portEntryId="sv"+portId
/*
        const {label,label_forName, input, type,
            meta:{
              touched, error, warning
            }
           } = this.props*/
          return (
           <Field   name={portEntryId } id={portEntryId} placeholder={portEntryId}  component={svpicker}   showTime={false} >
        
          </Field> )
           {/*  return (<div className="form-group">
                <label  forName={label_forName}>{label}
                </label>
                <input   onBlur={() => console.log('sv') }  {...input} type={type} id={portEntryId} className="form-control" placeholder="SVparalleltask"  />
                { touched && ((error && <span>{error}</span> )) || (warning && <span>{warning}</span>) }
            
            </div>
      
             )  
 */}
       

    }
}